import { provideComponent } from "scrivito"

import { FavoritesPage } from "pages/project-page/favorites-page/FavoritesPage"
import { FavoritesPageConnector } from "pages/project-page/favorites-page/FavoritesPageConnector"

import { FavoritesPageObjClass } from "./FavoritesPageObjClass"

provideComponent(
  FavoritesPageObjClass,
  () => {
    return <FavoritesPageConnector key="favorites" />
  },
  {
    loading: () => <FavoritesPage />
  }
)
